import styled from "@emotion/styled";

import { fontRobotoCondensed, fontSourceSerif4 } from "shared/lib/styles";

import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import { Headline } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";

export const Title = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  column-gap: 12px;
  align-items: flex-start;

  margin-block-start: 8px;
  padding-block-start: 8px;
  border-block-start: 1px #dfdfdf solid;
`;

export const DisplayNumber = styled.div`
  color: #2c4692;
  font-weight: 300;
  font-size: 48px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
`;

export const StyledContentItem = styled(ContentItemHomeSecondaryV2)`
  ${Headline} {
    a {
      text-decoration: none;
    }
    h2 {
      padding-block-start: 6px;

      color: #000000;
      font-weight: 600;
      font-size: 15px;
      font-family: ${fontSourceSerif4};
      font-style: normal;
      line-height: 130%;
      letter-spacing: -0.15px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;

  padding-block-start: 12px;
  border-block-start: 1px solid #dfdfdf;

  ${Title}+${ItemContainer} {
    margin-block-start: 0;
    border-block-start: none;
  }
`;
